import * as React from 'react';

function SvgTrackReturned({ className }) {
  return (
    <svg className={className} width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.95837 13.4583C3.95837 13.8783 4.12519 14.281 4.42212 14.5779C4.71905 14.8749 5.12178 15.0417 5.54171 15.0417C5.96163 15.0417 6.36436 14.8749 6.66129 14.5779C6.95823 14.281 7.12504 13.8783 7.12504 13.4583C7.12504 13.0384 6.95823 12.6357 6.66129 12.3387C6.36436 12.0418 5.96163 11.875 5.54171 11.875C5.12178 11.875 4.71905 12.0418 4.42212 12.3387C4.12519 12.6357 3.95837 13.0384 3.95837 13.4583ZM11.875 13.4583C11.875 13.8783 12.0419 14.281 12.3388 14.5779C12.6357 14.8749 13.0384 15.0417 13.4584 15.0417C13.8783 15.0417 14.281 14.8749 14.578 14.5779C14.8749 14.281 15.0417 13.8783 15.0417 13.4583C15.0417 13.0384 14.8749 12.6357 14.578 12.3387C14.281 12.0418 13.8783 11.875 13.4584 11.875C13.0384 11.875 12.6357 12.0418 12.3388 12.3387C12.0419 12.6357 11.875 13.0384 11.875 13.4583Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.95833 13.4584H2.375V4.75004C2.375 4.54008 2.45841 4.33871 2.60687 4.19025C2.75534 4.04178 2.9567 3.95837 3.16667 3.95837H10.2917V8.70837H6.33333M6.33333 8.70837L7.91667 10.2917M6.33333 8.70837L7.91667 7.12504M7.125 13.4584H11.875M10.2917 4.75004H14.25L16.625 8.70837V13.4584H15.0417"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

  );
}

export default SvgTrackReturned;
